import type { Observable } from 'rxjs';
import type {
  LoadExistingUserProfileInput,
  LoadExistingUserProfileResult,
} from '../models/existing-user-profile.model';

export abstract class ExistingUserProfilePort {
  abstract load(input: LoadExistingUserProfileInput): Observable<LoadExistingUserProfileResult>;
}
